import React from 'react';
import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';

const TabsWrapper = styled(Box)`
	border-bottom: 1px solid rgba(255, 255, 255, 0.12); 
`;

export default TabsWrapper;